import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import CheckBox from '../../../../../../atomic/formElements/checkBox/CheckBox';
import CandleTrailDocs from '../../../../documentation/CandleTrailDocumentation';
import NumberInputWithUnitDropdown from '../../../../../../atomic/inputs/numberInputWithUnitDropdown/NumberInputWIthUnitDropdown';

const timeUnits = [
  {
    text: 'Min.',
    value: 'MINUTES',
  },
  {
    text: 'Day',
    value: 'DAYS',
  },
  {
    text: 'Week',
    value: 'WEEKS',
  },
  {
    text: 'Month',
    value: 'MONTHS',
  },
  {
    text: 'Quarter',
    value: 'QUARTERS',
  },
  {
    text: 'Year',
    value: 'YEARS',
  },
];

function CandleTrailModule({ state }) {
  const [candleTrail, dispatchCandleTrail, , setCandleTrailEnabled] = state;

  const [breakByDisplay, setBreakByDisplay] = useState('');
  const [candleDurationDisplay, setCandleDurationDisplay] = useState(0);

  useEffect(() => {
    setCandleTrailEnabled(true);
  }, []);
  
  useEffect(() => {
    setBreakByDisplay(candleTrail.breakBy);
  }, [state]);

  useEffect(() => {
    setCandleDurationDisplay(candleTrail.candleDuration ?? 0);
  }, [candleTrail]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={CandleTrailDocs} /> Candle Trail
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Candle Duration</p>
          <NumberInputWithUnitDropdown
            list={timeUnits}
            inputVal={candleDurationDisplay}
            setInputVal={setCandleDurationDisplay}
            selectVal={candleTrail.timeUnit}
            onBlur={(value) => dispatchCandleTrail({ candleDuration: value })}
            setSelectVal={(value) => dispatchCandleTrail({ timeUnit: value })}
          />
        </div>
        {/*
          <p>Candle Duration</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={durationDisplay}
            setValue={setDurationDisplay}
            onBlur={(value) => dispatchCandleTrail({ candleDuration: value })}
          >
            min.
          </NumberInputWithUnit>
        */}
        <div className={style.inputAndLabel}>
          <p>Break By</p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={breakByDisplay}
            setValue={setBreakByDisplay}
            onBlur={(value) => dispatchCandleTrail({ breakBy: value })}
          >
            $
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p>Pre/Post Data</p>
          <CheckBox
            checked={candleTrail.usePrePostMarketData}
            onChange={(checked) =>
              dispatchCandleTrail({ usePrePostMarketData: checked })
            }
          ></CheckBox>
        </div>
      </div>
    </div>
  );
}
CandleTrailModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default CandleTrailModule;
